<template>
  <div id="auth_login">
    <div class="form_container combo_1">
      <div class="language-bar">
        <base-language-bar></base-language-bar>
      </div>

      <img
        class="'mw100 auth_logo combo_1'"
        src="../../assets/images/stratumblue_white_outline_logo.png"
      />

      <!-- <div class="blu-prices">
        <blu-prices-header></blu-prices-header>
      </div> -->

      <div class="combo_1">
        <label>
          <!-- {{ $t("msg.userid") }} -->
        </label>
        <the-mask
          class="input_write_form"
          :mask="['######']"
          v-model="loginform.userid"
          :masked="true"
          placeholder="ex:123456"
        ></the-mask>
        <span class="help is-danger" v-show="hasError.userid">{{
          $t(`msg.${errorMsg.userid}`)
        }}</span>
        <span
          class="text_sm tal_c dis_b your_id_is"
          v-html="$t('msg.your_id_is')"
        ></span>
      </div>

      <div class="combo_1">
        <label>
          {{ $t("msg.password") }}
        </label>
        <input
          class="input_write_form"
          type="password"
          :style="errorInputStyle.password"
          :placeholder="$t('msg.password')"
          v-model="loginform.password"
          @keyup="onChangeRemoveError(loginform, 'password')"
        />
        <span class="help is-danger" v-show="hasError.password">{{
          $tc(`msg.${errorMsg.password}`, 1)
        }}</span>
      </div>

      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 25px;
          margin-bottom: 25px;
          z-index: 1 !important;
        "
      >
        <vue-recaptcha
          ref="recaptcha"
          sitekey="6Ld5qccaAAAAAH5xmkU8cw9CA1UwtP66KcL-UP2f"
          :loadRecaptchaScript="true"
          @verify="onCaptchaVerified"
          @expired="onCaptchaExpired"
        ></vue-recaptcha>
      </div>

      <div class="combo_1" style="z-index: 10 !important; margin-top: 70px;">
        <button v-if="loading" class="regular_submit">
          {{ $t("msg.loading") }}...
        </button>

        <button v-else type="submit" @click="submitLogin">
          {{ $t("msg.login") }}
        </button>
      </div>

      <div class="tal_c">
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-top: 0.5rem;
          "
        >
          <router-link :to="{ name: 'recoveruserid' }" exact>
            <a class="main_white_fill combo_1 dis_b text_sm">
              <span class="fat">{{ $t("msg.recover_userid") }}</span>
            </a>
          </router-link>

          <router-link :to="{ name: 'recoverpassword' }" exact>
            <a class="main_white_fill combo_1 dis_b text_sm">
              <span class="fat">{{ $t("msg.recover_password") }}</span>
            </a>
          </router-link>
        </div>

        <!-- <router-link :to="{ name: 'signup' }" exact class="not_member_yet">
          <a>
            <span class="fat">{{ $t("msg.open_account") }}</span>
          </a>
        </router-link> -->
      </div>
    </div>
  </div>
</template>

<script>
import BaseWrittenLogo from "../../components/public/BaseWrittenLogo";
import BaseLanguageBar from "../../components/public/BaseLanguageBar";
import BluPricesHeader from "../../components/public/BluPricesHeader";

import { TheMask } from "vue-the-mask";
import VueRecaptcha from "vue-recaptcha";
import { mapGetters } from "vuex";

class LoginFields {
  constructor() {
    this.userid = "";
    this.password = "";
  }
}

export default {
  name: "login",

  created() {
    if (this.$route.query.user) {
      this.loginform.userid = this.$route.query.user;
    }
  },
  mounted() {
    if (this.activationHash != "") {
      this.notifySuccess(this.$t("msg.activating_account"), 5000);
      this.activate(this.activationHash);
    }
    this.setValidationFields(LoginFields);
    this.$store.dispatch("getCurrencies");
    this.$store.dispatch("getFundTailsBtc");
  },
  props: {
    activationHash: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    loginform: new LoginFields(),
    loading: false,
    recaptchaToken: "",
    buttonOff: true,
  }),
  methods: {
    async activate(code) {
      try {
        await this.$store.dispatch("putActivateMember", code);
        this.notifySuccess(this.$t("msg.activation_successful"), 5000);
      } catch (error) {
        if (error.response.status === 404) {
          this.notifyDanger(this.$t("msg.activation_link_invalid"));
        } else {
          this.notifyDanger(error, 5000);
        }
      }
    },

    onCaptchaVerified: function (recaptchaToken) {
      this.recaptchaToken = recaptchaToken;
    },

    onCaptchaExpired: function () {
      this.recaptchaToken = "";
      this.$refs.recaptcha.reset();
    },
    submitLogin() {
      const form = this.loginform;

      this.showOrHideError("userid", this.validateUserId(form.userid));
      this.showOrHideError("password", form.password);
      const formPayload = {
        id: form.userid,
        password: form.password,
        recaptchaToken: this.recaptchaToken,
      };

      if (this.buttonOff) {
        this.notifyDanger(this.$t("msg.confirm_recaptcha"), 5000);
      } else {
        this.checkIfFormHasErrorsAndSubmit(
          formPayload,
          this.postLoginForm,
          this.afterSubmitSuccess,
          this.afterSubmitError
        );

        this.onCaptchaExpired();
      }
    },
    afterSubmitSuccess(resp) {
      this.loading = false;
      this.notifySuccess(this.$t("msg.login_successful"));
      this.$store.commit("setAuthCookie", resp.data.access_token);
      this.$store.commit("setAuthorized", true);
      this.$router.push("home");
    },
    afterSubmitError(error) {
      this.loading = false;
      this.showError("userid", "invalid_credentials");
      this.showError("password", "invalid_credentials");
      this.notifyDanger(error);
    },
    postLoginForm(form) {
      this.loading = true;
      return this.$store.dispatch("postSignin", form);
    },
  },
  components: {
    BaseWrittenLogo,
    TheMask,
    VueRecaptcha,
    BaseLanguageBar,
    BluPricesHeader,
  },
  computed: {
    ...mapGetters(["currencies"]),
  },

  watch: {
    recaptchaToken: function () {
      if (this.recaptchaToken == "") {
        this.buttonOff = true;
      } else {
        this.buttonOff = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/public/Login.vue